// extracted by mini-css-extract-plugin
module.exports =  {"card":"da51a739f7--card--U31TK","image":"da51a739f7--image--qvR4O","image--desktop":"da51a739f7--image--desktop--u8ExG"};